/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { Stack, Typography, IconButton, Tooltip, CircularProgress } from '@mui/material';
import { useObjectContext } from '@/hooks/useObjectContext';
import { useDispatch } from 'react-redux';
import { Refresh } from '@mui/icons-material';
import {
	useGetDealsByClientIdQuery,
	useRefreshDealPoliciesMutation,
} from '@/features/deals/dealsApi';
import { useParams } from 'react-router-dom';
import { triggerRefresh } from '@/features/table/dealsTableSlice';

const RefreshPolicyButton = () => {
	const params = useParams();

	const dispatch = useDispatch();

	const { clientRow, dealRow } = useObjectContext();

	const isDeal = Boolean(params?.dealId);
	const isClient = Boolean(params?.clientId);
	const isDebtor = dealRow?.pipeline === process.env.REACT_APP_PIPELINE_DEBTORS;

	const { currentData: clientDeals = [] } = useGetDealsByClientIdQuery(clientRow?.clientId, {
		skip: !isClient || !clientRow?.clientId,
	});
	const clientDealIds = clientDeals
		.filter((deal) => deal.pipeline !== process.env.REACT_APP_PIPELINE_CLAIMS)
		.map((deal) => deal.dealId);

	const [refreshDealPolicies, { isLoading }] = useRefreshDealPoliciesMutation();

	const dealText = isDeal ? 'this deal' : "this client's deals";
	const TooltipText = () => (
		<Stack spacing={2}>
			<Typography variant='inherit'>
				{isDebtor
					? 'this will refresh all invoices associated with this debtor including updating all balances'
					: `This will refresh all policies associated with ${dealText} and update its renewal date according to the to/from date of the policies associated with it.`}
			</Typography>
		</Stack>
	);

	return (
		<>
			{(isDeal || isClient) && (
				<Tooltip title={<TooltipText />}>
					<div>
						<IconButton
							size='small'
							disabled={
								isLoading ||
								(isDeal && !dealRow?.dealId) ||
								(isClient && clientDealIds.length === 0)
							}
							onClick={async () => {
								const res = await refreshDealPolicies({
									dealIds: isDeal ? [dealRow.dealId] : clientDealIds,
									clientId: clientRow?.clientId,
								})
									.unwrap()
									.then(() => {
										if (isClient) {
											dispatch(triggerRefresh());
										}
									});
							}}
						>
							{isLoading ? (
								<CircularProgress size='16px' />
							) : (
								<Refresh sx={{ fontSize: '18px' }} />
							)}
						</IconButton>
					</div>
				</Tooltip>
			)}
		</>
	);
};

export default RefreshPolicyButton;
